import {CxEvent} from '@spartacus/core';

export class EddlLoginEvent extends CxEvent {
  static readonly type = 'EddlLoginEvent';
}
